<template>
  <v-snackbar
    v-model="visible"
    :color="color"
    :timeout="timeout"
    bottom
    right
  >
    <v-icon left dark>
      {{
        color === 'error'
          ? 'mdi-alert-circle-outline'
          : color === 'success'
            ? 'mdi-check-circle'
            : ''
      }}
    </v-icon>
    {{ text }}
    <v-btn
      @click="visible = false"
      dark
      text
      rounded
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { EventBus } from 'utils';
import * as Sentry from '@sentry/browser';

export default {
  name: 'Alert',

  data() {
    return {
      visible: false,
      timeout: 5000,
      color: '',
      text: '',
    };
  },

  created() {
    EventBus.$on('alert-error', info => this.triggerError(info, 'error'));
    EventBus.$on('alert-success', info => this.triggerError(info, 'success'));
  },

  methods: {
    triggerError(info, type) {
      this.visible = true;
      this.timeout = type === 'error' ? 0 : 5000;
      this.color = type;

      if (type === 'error') {
        if (typeof info === 'object') {
          this.text = `An error has occured please try again.`;
        } else if (typeof info === 'string' && info.includes('You must enable send to segment')) {
          this.text =
            'You must enable send to segment and select at least one state this notification should be sent to';
        } else if (
          typeof info === 'string' &&
          info.includes('You must enable Only send notification')
        ) {
          this.text = `You must enable 'Only send notification within state' and select one state this notification should be sent to.`;
        } else if (typeof info === 'string' && info.includes('To schedule a notification')) {
          this.text = 'To schedule a notification, you must select a date on the calendar.';
        } else {
          this.text = 'An error occured. Please try again.';
        }

        Sentry.captureException(info);
      } else {
        this.text = info;
      }
    },
  },
};
</script>
